import styled from "styled-components";
import { carryType } from "../../types/types";

const Wrapper = styled.div<{ $isMethod?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.4vw;
  width: 10vw;
  height: 4.6vw;
  background-color: white;
  font-size: ${(props) => (props.$isMethod ? "1.8vw" : "2vw")};
`;
export default function DisplayInputComponent(props: any) {
  const { data, isMethod } = props;
  const carryTypeList = carryType;

  return (
    <Wrapper $isMethod={isMethod}>
      {isMethod ? carryTypeList[data].status : data}
    </Wrapper>
  );
}
